module.exports = __webpack_public_path__ + "svgs/bostad_rent_illustration.59bcdac660c79d504e891dbe008223a8.svg";